/**
 * /pro-hosting — migrated from public/js/pro-hosting.js.
 * 1. Sticky-bookmarks (shared)
 * 2. .btn-resources popupBox
 * 3. .popup-box .info — switch inf-N panels
 * 4. .plan i.tooltip + .green-text Tooltip
 * 5. Switch button toggle (shared switch-packages)
 */
import { Resort } from '../core/resort.js';
import { initStickyBookmarks } from '../shared/sticky-bookmarks.js';
import { initSwitchPackages } from '../shared/switch-packages.js';

new Resort(() => {
    initStickyBookmarks();

    ($('a.btn-resources', true) as NodeListOf<Element>).popupBox();

    ($('.popup-box .info', true) as NodeListOf<Element>).on('click', 'a', function (this: Element) {
        const parent = this.parents('.popup-box') as HTMLElement | null;
        parent?.find('.inf', (inf: Element) => { inf.classList.add('hide'); return true; });
        const idx = (this as HTMLElement).dataset['index'];
        (parent?.find(`.inf-${idx}`) as Element | null)?.classList.remove('hide');
    });

    ($('.plan i.tooltip, .green-text', true) as NodeListOf<Element>).Tooltip();

    initSwitchPackages('.switch-btn');
});
